import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'validTime'})

export class ValidTime implements PipeTransform {

    public transform(dateTime: Date, fromHour: number, toHour: number): boolean {
        const date = moment(dateTime);
        if (date.isValid() && (date.hours() < fromHour || (date.hours() > toHour || date.hours() > (toHour - 1) && date.minutes() > 0))) {
        return false;
        } else {
        return true;
        }
    }
}
